import React from 'react';
import Details_Header from '../Details_Header/Details_Header';

const Contract_Details = ({ details, noAction }) => {
  return (
    <React.Fragment>
      <Details_Header
        details={details}
        noAction={noAction}
      />
    </React.Fragment>
  );
};

export default Contract_Details;
